/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IReferenceNode } from '../../core/models/IReferenceNode';
import { Node } from '../../core/models/Node';
import { Operation } from '../../core/models/common/Operation';
import { Tag } from '../../core/models/common/Tag';
import { AaiOperationBindings } from './AaiOperationBindings';
import { Document } from '../../core/models/Document';
import { AaiTag } from './AaiTag';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} opType
 * @class
 * @extends Operation
 * @author Jakub Senko <jsenko@redhat.com>
 */
export abstract class AaiOperationBase extends Operation implements IReferenceNode {
    public $ref : string;

    public tags : Array<Tag>;

    public bindings : AaiOperationBindings;

    public constructor(parent? : any, opType? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof opType === 'string') || opType === null)) {
            let __args = arguments;
            super(opType);
            if(this.$ref===undefined) this.$ref = null;
            if(this.tags===undefined) this.tags = null;
            if(this.bindings===undefined) this.bindings = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.tags===undefined) this.tags = null;
            if(this.bindings===undefined) this.bindings = null;
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(((typeof parent === 'string') || parent === null) && opType === undefined) {
            let __args = arguments;
            let opType : any = __args[0];
            super(opType);
            if(this.$ref===undefined) this.$ref = null;
            if(this.tags===undefined) this.tags = null;
            if(this.bindings===undefined) this.bindings = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.tags===undefined) this.tags = null;
            if(this.bindings===undefined) this.bindings = null;
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && opType === undefined) {
            let __args = arguments;
            {
                let __args = arguments;
                let opType : any = null;
                super(opType);
                if(this.$ref===undefined) this.$ref = null;
                if(this.tags===undefined) this.tags = null;
                if(this.bindings===undefined) this.bindings = null;
                if(this.$ref===undefined) this.$ref = null;
                if(this.tags===undefined) this.tags = null;
                if(this.bindings===undefined) this.bindings = null;
                (() => {
                    if(parent != null) {
                        this._parent = parent;
                        this._ownerDocument = parent.ownerDocument();
                    }
                })();
            }
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    public addTag$io_apicurio_datamodels_asyncapi_models_AaiTag(tag : AaiTag) {
        if(this.tags == null) this.tags = <any>([]);
        /* add */(this.tags.push(tag)>0);
    }

    public addTag$java_lang_String$java_lang_String(name : string, description : string) : AaiTag {
        let tag : AaiTag = this.createTag();
        tag.name = name;
        tag.description = description;
        if(this.tags == null) {
            this.tags = <any>([]);
        }
        /* add */(this.tags.push(tag)>0);
        return tag;
    }

    /**
     * Adds a tag.
     * 
     * @param {string} name
     * @param {string} description
     * @return {AaiTag}
     */
    public addTag(name? : any, description? : any) : any {
        if(((typeof name === 'string') || name === null) && ((typeof description === 'string') || description === null)) {
            return <any>this.addTag$java_lang_String$java_lang_String(name, description);
        } else if(((name != null && name instanceof <any>AaiTag) || name === null) && description === undefined) {
            return <any>this.addTag$io_apicurio_datamodels_asyncapi_models_AaiTag(name);
        } else throw new Error('invalid overload');
    }

    public abstract createTag() : AaiTag;
}
AaiOperationBase["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiOperationBase";
AaiOperationBase["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];




